module.exports = __webpack_public_path__ + "static/media/pic_ka_hj.37d8fd30.png";